import { render, staticRenderFns } from "./AssociatedPersonsInput.vue?vue&type=template&id=bba12d20&scoped=true&"
import script from "./AssociatedPersonsInput.vue?vue&type=script&lang=ts&"
export * from "./AssociatedPersonsInput.vue?vue&type=script&lang=ts&"
import style0 from "./AssociatedPersonsInput.vue?vue&type=style&index=0&id=bba12d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba12d20",
  null
  
)

export default component.exports